var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.ad09d09f7dc54b2dfe5507d247c37b89.svg#bb';
                    var viewUrl = 'sprites.ad09d09f7dc54b2dfe5507d247c37b89.svg#view-bb';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 57 37',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };